var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-form__section edit-note-section"},[_c('div',{staticClass:"post-form__field"},[_vm._v(_vm._s(_vm.noteText))])])}
var staticRenderFns = []

export { render, staticRenderFns }